<div class="score-container">
  <!-- ✅ Button now uses manager_level color -->
  <button
    type="button"
    class="shared-score-size text-white"
    [ngClass]="[buttonClass, currentScore ? 'text-white' : 'text-black']"
    [disabled]="disabled"
    (click)="toggleDropdown()"
  >
    V
  </button>
  <!-- Dropdown -->
  <ul *ngIf="isDropdownOpen" class="dropdown-list">
    <li
      *ngFor="let option of options"
      class="shared-score-size text-white"
      [ngClass]="option.class"
      (click)="selectScore(option.quiz_question_answer_id)"
    >
      V
    </li>
  </ul>
</div>
